import { Draft } from '@reduxjs/toolkit'
import { produce } from 'immer'
import LAYER_KEYS from '~/config/layerKeys'
import { ObjectsState } from '~/store/objects/reducer'

export const patchupBackgroundImage = (data: ObjectsState) => {
  return produce(data, (facility: Draft<ObjectsState>) => {
    const backgroundImage = facility.backgroundImage?.[LAYER_KEYS.BACKGROUND_IMAGE]
    if (!backgroundImage) return
    if (!backgroundImage.position) backgroundImage.position = { x: 0, y: 0, z: 0 }
    if (!backgroundImage.rotation) backgroundImage.rotation = { x: 0, y: 0, z: 0 }
  })
}
